import React, { useState } from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { SwatchesPicker } from 'react-color';
import { setEditTab } from '../actions/apiSetInfo';
import { updateTabSetting } from '../actions/apiDealerUpdates';
import { change_page } from '../actions/toggleMenu';

const EditTabSettingsWithDealership = (props) => {
    const [value, setValue] = useState(props.value || '');
    const [checked, setChecked] = useState(props.checked || '');

    const dispatch = useDispatch();

    // Use useSelector to access vehicle_columns and departments from the Redux store
    const vehicleColumns = useSelector((state) => state.settings_departments.vehicle_columns);
    const departments = useSelector((state) => state.settings_departments.departments);

    const onChange = (e) => {
        setValue(e.target.value);
    };

    const onBlur = (e) => {
        if (e.target.value !== props.value) {
            const errorType = 'editTabSetting';
            const id = props.dataid;
            const data = {
                id,
                [props.name]: e.target.value,
            };

            setValue(e.target.value);
            dispatch(updateTabSetting(id, data, errorType));
        }
    };

    const onEditClick = () => {
        dispatch(setEditTab(props.name));
        dispatch(change_page('tab-settings-edit'));
    };

    const onChangeChecked = (e) => {
        const errorType = 'editTabSetting';
        const data = {
            id: props.dataid,
            active: e.target.checked,
        };
        setChecked(e.target.checked);

        dispatch(updateTabSetting(props.dataid, data, errorType));
    };

    const onChangeSelect = (e) => {
        if (e.value !== value) {
            const errorType = 'editTabSetting';
            const id = props.dataid;
            const data = {
                id,
                [props.name]: e.value,
            };

            setValue(e.value);
            dispatch(updateTabSetting(id, data, errorType));
        }
    };

    const selectData = () => {
        return vehicleColumns.map((option) => ({
            value: option.name,
            label: option.name,
        }));
    };

    const handleChangeComplete = (e) => {
        setValue(e.hex);

        const errorType = 'editColorPicker';
        const data = {
            id: props.dataid,
            [props.name]: e.hex,
        };

        dispatch(updateTabSetting(props.dataid, data, errorType));
    };

    const selectComparison = () => {
        const comparisonArray = [
            { name: 'Greater Than', label: 'Greater Than' },
            { name: 'Greater or Equal', label: 'Greater or Equal' },
            { name: 'Equals', label: 'Equals' },
            { name: 'Less Than', label: 'Less Than' },
            { name: 'Less or Equal', label: 'Less or Equal' },
        ];

        return comparisonArray.map((option) => ({
            value: option.name,
            label: option.label,
        }));
    };

    return (
        <div className="col-md-12">
                        <div className={classnames('form-group', { 'has-danger': props.error })}>
                            {(() => {
                                switch (props.type) {
                                    case 'switch':
                                        return (
                                            <span className="switch">
                                                <input
                                                    onChange={onChangeChecked}
                                                    type={'checkbox'}
                                                    name={props.name}
                                                    data-id={props.parentid}
                                                    checked={checked ? 'checked' : ''}
                                                    className={classnames('text-center', { 'form-control-danger': props.error })}
                                                    id={`switch_id_${props.name}`}
                                                />
                                                <label className={'text-capitalize'} htmlFor={`switch_id_${props.name}`} />
                                            </span>
                                        );

                                    case 'switch-edit':
                                        return (
                                            <div>
                                                <span className="switch">
                                                    <input
                                                        onChange={onChangeChecked}
                                                        type={'checkbox'}
                                                        name={props.name}
                                                        data-id={props.dataid}
                                                        checked={checked ? 'checked' : ''}
                                                        className={classnames('text-center', { 'form-control-danger': props.error })}
                                                        id={`switch_id_${props.name}`}
                                                    />
                                                    <label className={'text-capitalize'} htmlFor={`switch_id_${props.name}`}>{props.label.replace(/_/g, ' ')}</label>
                                                </span>
                                                {checked ? (
                                                    <button className={'btn btn-success btn-sm float-end'} onClick={onEditClick}>
                                                        <i className="fa fa-edit" />
                                                        {' '}
                                                        Settings
                                                    </button>
                                                ) : ''}
                                            </div>
                                        );

                                    case 'switch-nolabel':
                                        return (
                                            <span className="switch">
                                                <input
                                                    onChange={onChangeChecked}
                                                    type={'checkbox'}
                                                    name={props.name}
                                                    data-id={props.parentid}
                                                    checked={checked ? 'checked' : ''}
                                                    className={classnames('text-center', { 'form-control-danger': props.error })}
                                                    id={`switch_id_${props.name}`}
                                                />
                                                <label className={'text-capitalize'} htmlFor={`switch_id_${props.name}`} />
                                            </span>
                                        );

                                    case 'text':
                                        return (
                                            <input
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={value}
                                                type={props.type}
                                                name={props.name}
                                                data-id={props.dataid}
                                                className={classnames('form-control', { 'form-control-danger': props.error })}
                                            />
                                        );

                                    case 'number-prepend':
                                        return (
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text" id="basic-addon3">Tab Order:</span>
                                                </div>
                                                <input
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={value}
                                                    type={'number'}
                                                    name={props.name}
                                                    data-id={props.dataid}
                                                    className={classnames('form-control', { 'form-control-danger': props.error })}
                                                    aria-describedby="basic-addon3"
                                                />
                                            </div>
                                        );

                                    case 'text-prepend':
                                        return (
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text" id="basic-addon3">{props.label}</span>
                                                </div>
                                                <input
                                                    onChange={onChange}
                                                    onBlur={onBlur}
                                                    value={value}
                                                    type={'text'}
                                                    name={props.name}
                                                    data-id={props.dataid}
                                                    className={classnames('form-control', { 'form-control-danger': props.error })}
                                                    aria-describedby="basic-addon3"
                                                />
                                            </div>
                                        );

                                    case 'checkbox':
                                        return (
                                            <span className="switch">
                                                <input
                                                    onChange={onChangeChecked}
                                                    type={'checkbox'}
                                                    name={props.name}
                                                    data-id={props.parentid}
                                                    checked={checked ? 'checked' : ''}
                                                    className={classnames('text-center', { 'form-control-danger': props.error })}
                                                    id={`switch_id_${props.name}`}
                                                />
                                                <label className={'text-capitalize'} htmlFor={`switch_id_${props.name}`}>{props.label.replace(/_/g, ' ')}</label>
                                            </span>
                                        );

                                    case 'colorpicker':
                                        return (
                                            <div className="form-group">
                                                <label className="control-label">{props.label}</label>
                                                <SwatchesPicker
                                                    color={value}
                                                    onChangeComplete={handleChangeComplete}
                                                    type={props.type}
                                                    name={props.name}
                                                    data-id={props.parentid}
                                                    width={'100%'}
                                                />
                                            </div>
                                        );

                                    case 'select-comparison':
                                        return (
                                            <Select
                                                onChange={onChangeSelect}
                                                value={selectComparison().filter(({ value }) => value === value)}
                                                name={props.name}
                                                options={selectComparison()}
                                                className="text-capitalize"
                                                data-id={props.dataid}
                                                clearable={false}
                                                searchable={false}
                                                menuContainerStyle={{ zIndex: 5 }}
                                            />
                                        );

                                    case 'select-data':
                                        return (
                                            <Select
                                                onChange={onChangeSelect}
                                                value={selectData().filter(({ value }) => value === value)}
                                                name={props.name}
                                                options={selectData()}
                                                className="text-capitalize"
                                                data-id={props.dataid}
                                                clearable={false}
                                                searchable
                                                menuContainerStyle={{ zIndex: 5 }}
                                            />
                                        );

                                    default:
                                        return (
                                            <input
                                                onChange={onChange}
                                                value={value}
                                                type={props.type}
                                                name={props.field}
                                                className={classnames('form-control', { 'form-control-danger': props.error })}
                                            />
                                        );
                                }
                            })()}
                        </div>
                    </div>
    );
};

export default EditTabSettingsWithDealership;